import React,{useState} from 'react'
import Header from '../../components/Header/Header';
import Subscriptions from '../../components/Subscriptions/Subscriptions';

function ProductsPage() {
  const [subscriptionData, setSubscriptionData] = useState(null);

  const handleDataFromSubscriptions = (data) => {
    setSubscriptionData(data);
  };

  return (
    <Header subscriptionData={subscriptionData}>
       <div>
        <Subscriptions sendDataToParent={handleDataFromSubscriptions} />
      </div>
    </Header>
  )
}

export default ProductsPage;
